/* eslint-disable no-console */
import {Logger} from '@practicegenius/domain/src/common/logger';
import {Navigator} from './navigator';

export const initialLogger: Logger = {
  debug: console.debug,
  info: console.info,
  warning: console.warn,
  error: console.error,
  critical: console.error,
};

const reportInvalidNavigator = (...args: any[]) => {
  throw new Error(`Invalid usage of NilNavigator with args ${args}`);
};

export class NilNavigator implements Navigator {
  location = {
    pathname: 'invalid',
    params: {},
    state: {},
  };

  navigate(route: string, params?: Record<string, unknown>) {
    reportInvalidNavigator('navigate', route, params);
  }
  push(route: string, params?: Record<string, unknown>) {
    reportInvalidNavigator('push', route, params);
  }
  replace(route: string) {
    reportInvalidNavigator('replace', route);
  }
  goBack() {
    reportInvalidNavigator('goBack');
  }
  isCurrentRoute(route: string): boolean {
    reportInvalidNavigator('isCurrentRoute', route);
    return false;
  }
}
